import { render, staticRenderFns } from "./SelectHeartLungs.vue?vue&type=template&id=3a28e08e"
import script from "./SelectHeartLungs.vue?vue&type=script&lang=js"
export * from "./SelectHeartLungs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports